import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VueMarkdown from 'vue-markdown';
import CardSet from '@/components/CardSet.vue';
import Loading from '@/components/Loading.vue';
const classesModule = namespace('classes');
const blobsModule = namespace('blobs');
let HandbookClasses = class HandbookClasses extends Vue {
    created() {
        this.fetchHandbookBlob('Classes');
        this.fetchClasses();
    }
    get blob() {
        return this.handbookBlobs['Classes'];
    }
    get classesWithLinks() {
        return this.classes.map(charClass => ({
            ...charClass,
            to: `classes/${charClass.name}`
        }));
    }
    showSaves(saves) {
        return saves.join(' and ');
    }
};
__decorate([
    classesModule.State
], HandbookClasses.prototype, "classes", void 0);
__decorate([
    classesModule.Action
], HandbookClasses.prototype, "fetchClasses", void 0);
__decorate([
    blobsModule.State
], HandbookClasses.prototype, "handbookBlobs", void 0);
__decorate([
    blobsModule.Action
], HandbookClasses.prototype, "fetchHandbookBlob", void 0);
HandbookClasses = __decorate([
    Component({
        components: {
            VueMarkdown,
            Loading,
            CardSet
        }
    })
], HandbookClasses);
export default HandbookClasses;
